import React from 'react';

export default function PrivacyPolicy() {
    const lastUpdated = "August 21, 2026";
    const appName = "blvd.ltd";
    const contactEmail = "mail@blvd.ltd";

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'sans-serif', lineHeight: '1.6' }}>
            <h1>Privacy Policy</h1>
            <hr/>
            <p><strong>Last Updated:</strong> {lastUpdated}</p>

            <section>
                <h2>1. Information We Collect</h2>
                <p>
                    We collect minimal information necessary to provide our service:
                </p>
                <ul>
                    <li><strong>Usage Data:</strong> Basic browser telemetry, IP addresses, and page access logs via local storage or analytics.</li>
                    <li><strong>User Inputs:</strong> Information you explicitly enter into forms or account settings.</li>
                </ul>
            </section>

            <section>
                <h2>2. How We Use Information</h2>
                <p>
                    We use the collected information solely to maintain, improve, and secure {appName},
                    and to communicate with you when necessary.
                </p>
            </section>

            <section>
                <h2>3. Cookies & Local Storage</h2>
                <p>
                    This React application uses local storage, session storage, or standard cookies to persist
                    your session state and user preferences.
                </p>
            </section>

            <section>
                <h2>4. Third-Party Services</h2>
                <p>
                    We do not sell your data. We may share anonymized data with third-party service providers
                    (such as hosting or analytics platforms) strictly to run this service.
                </p>
            </section>

            <section>
                <h2>5. Your Data Rights</h2>
                <p>
                    Depending on your location (such as GDPR or CCPA jurisdictions), you have rights to access,
                    correct, or request deletion of your personal data by contacting us.
                </p>
            </section>

            <section>
                <h2>6. Contact Us</h2>
                <p>
                    For privacy-related inquiries, reach us at: <strong>{contactEmail}</strong>
                </p>
            </section>
        </div>
    );
}